import { render } from "./career.vue?vue&type=template&id=060ba923"
import script from "./career.vue?vue&type=script&lang=js"
export * from "./career.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__